/* __next_internal_client_entry_do_not_use__ FilterablePaginatedSectionContext,FilterablePaginatedSectionContextProvider auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useFilterablePaginatedScroll } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/useFilterablePaginatedScroll";
import React, { useTransition, useState, createContext } from "react";
export var FilterablePaginatedSectionContext = /*#__PURE__*/ createContext({
    isTransitioning: false,
    startTransition: function() {}
});
export var FilterablePaginatedSectionContextProvider = function(param) {
    var children = param.children;
    var _useFilterablePaginatedScroll = useFilterablePaginatedScroll(), scrollRef = _useFilterablePaginatedScroll.scrollRef, scrollToTop = _useFilterablePaginatedScroll.scrollToTop;
    var _useState = _sliced_to_array(useState(false), 2), isScrollingToTop = _useState[0], setIsScrollingToTop = _useState[1];
    var _useTransition = _sliced_to_array(useTransition(), 2), isTransitioning = _useTransition[0], startTransition = _useTransition[1];
    var _useState1 = _sliced_to_array(useState(null), 2), navigationTreeRenderedComponent = _useState1[0], setNavigationTreeRenderedComponent = _useState1[1];
    return /*#__PURE__*/ _jsx(FilterablePaginatedSectionContext.Provider, {
        value: {
            scrollRef: scrollRef,
            scrollToTopFunc: scrollToTop,
            isScrollingToTop: isScrollingToTop,
            setIsScrollingToTop: setIsScrollingToTop,
            isTransitioning: isTransitioning,
            startTransition: startTransition,
            navigationTreeRenderedComponent: navigationTreeRenderedComponent,
            setNavigationTreeRenderedComponent: setNavigationTreeRenderedComponent
        },
        children: children
    });
};
